/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Breadcrumb } from 'matx';
import { Icon, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { getMenuList, GET_MENU_LIST } from 'app/redux/actions/MenuActions';
import MenuTable from '../shared/MenuTable';

const Menus = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch({
      type: GET_MENU_LIST,
      payload: []
    });
    
    dispatch(getMenuList());
  }, []);

  return (
    <div className="m-sm-30 menu">
      <div className="mb-sm-30 flex items-center justify-between">
        <Breadcrumb
          routeSegments={[
            { name: 'Menus', path: '/menus/list' },
            { name: 'List' }
          ]}
        />
        <div className="">
          <Button
            component={RouterLink}
            to="/menus/add"
            variant="contained"
            color="primary"
            endIcon={<Icon>add</Icon>}
          >
            Add New
          </Button>
        </div>
      </div>
      <MenuTable />
    </div>
  );
};

export default Menus;
